module.exports = __webpack_public_path__ + "img/tiqi.cfb08e42.png";